




















import { Component, Vue, Provide } from 'vue-property-decorator'
import { City, defaultCity } from '@app/core/constant/city'
import ProductItem from './components/goodItem/index.vue'
import { List } from 'vant'
import { getSearchResult, getChannelData } from './service/index'
import { getSelectedCity, allowRefreshOrShare } from '@utils/index'
import WaterFall from '@shared/components/waterFall/index.vue'

@Component({
  components: {
    ProductItem,
    [List.name]: List,
    WaterFall,
  },
})
export default class ScenicTourism extends Vue {
  list: any = []
  placeholder = '请输入要搜索的商品'
  loading = true
  finished = false
  cityInfo: City = defaultCity
  templateType = 2 //templateType 1：个性化 2：通用
  pageInfo = {
    pafeSize: 10,
    pageStart: 0,
  }
  errormsg = '' //不为空 就实现错误页面
  channelData = {
    categoryIds: '',
    channelName: '',
  }

  @Provide()
  pageTrackParams: any = {}
  @Provide()
  clickid_city = ''
  @Provide()
  clickid_search = ''

  beforeCreate() {
    this.$setTitle('景点旅游')
  }

  async created() {
    window.scrollTo(0, 0)
    allowRefreshOrShare(false)
    //获取城市
    try {
      await this.fetchChannelData()
      this.cityInfo = await getSelectedCity()
      this.getList()
    } catch (error) {
      console.log('定位失败')
    }
  }

  onLoad() {
    this.getList()
  }

  //获取频道数据
  async fetchChannelData() {
    try {
      const res = await getChannelData(this.channelId, this.cityInfo.cityId)
      if (res && res.code === '1') {
        this.channelData = res.data
      }
    } catch (error) {
      console.log(error)
    }
  }

  async getList() {
    const { categoryIds } = this.channelData
    const data = {
      cityId: String(this.cityInfo.cityId),
      distanceSort: false,
      level4CategoryId: categoryIds,
      openOption: false,
      saleNumSort: false,
      start: this.pageInfo.pageStart,
      limit: this.pageInfo.pafeSize,
      tabs: '3',
      type: 3,
    }
    const res = await getSearchResult(data)
    setTimeout(() => {
      this.loading = false
    }, 500)
    if (res && res.code === '1') {
      this.list = [...this.list, ...res.data.cmmdtyInfo.list]
      this.pageInfo.pageStart += this.pageInfo.pafeSize
      if (this.list.length >= res.data.cmmdtyInfo.total) {
        setTimeout(() => {
          this.finished = true
        }, 500)
      }
      // 待瀑布流组装完高度撑起来后才让继续加载
    } else {
      this.errormsg = res.msg || '加载出错，请稍后再试'
    }
  }

  refresh() {
    this.reset()
    this.onLoad()
  }

  reset() {
    this.pageInfo.pageStart = 0
    this.list = []
  }

  get channelId() {
    return String(this.$route.query.channel)
  }
}
